import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Order } from 'src/app/core/models/order';

@Component({
    selector: 'app-payment-reminder',
    templateUrl: './payment-reminder.component.html',
    styleUrls: ['./payment-reminder.component.scss'],
})
export class PaymentReminderComponent {
    @Input({ required: true }) order!: Order;
    @Output() onResult: EventEmitter<boolean> = new EventEmitter<boolean>();

    confirmPayment(): void {
        this.onResult.emit(true);
    }

    close(): void {
        this.onResult.emit(false);
    }
}
